import React, { useEffect, useState, useRef } from 'react';

import axios from 'axios';
import moment from 'moment';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';

function StandingAlarm(props) {
    let ismount = useRef(true);
    let isfetch = useRef(false);
    let isfirst = useRef(true);

    const hot_update = useRef('-')
    const [reportsite, setReportsite] = useState('-');
    const [server_update, setServerUpdate] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"))
    const [modal_remark, setModal_remark] = useState(false);

    const [data_alarmevent_standing, setData_alarmevent_standing] = useState([])
    const [remark_display_id, setRemark_display_id] = useState('')
    const [sitefilter, setSitefilter] = useState([])
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        ismount.current = true
        if (!isfetch.current) {
            api_get_alarm()
        }
    }, [props.center_hot_update]);

    useEffect(() => {
        return () => {
            setData_alarmevent_standing([])
        };
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(code) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_get_alarm() {
        if (isfirst.current) {
            //setmodal_load({ enable: true, message: "Loading standing alarm & event data.." })
        }
        isfetch.current = true
        const formData = new FormData()
        formData.append('sitelist', props.permitdata.sitescope_str)
        formData.append('update_key', hot_update.current)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/alarmevent/standing", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                isfetch.current = false
                isfirst.current = false
                setmodal_load({ enable: false, message: "" })
                if (ismount.current) {
                    if (response.data.status === 'OK') {
                        if (response.data.alarmlist !== undefined) {
                            const nd = reorder_data(response.data.alarmlist)
                            setData_alarmevent_standing(nd)
                            setSitefilter(response.data.sitefilter)
                        }
                        if (response.data.update_key !== undefined) {
                            hot_update.current = response.data.update_key
                            setServerUpdate(response.data.update_key)
                        }
                    }
                    else {

                    }
                }
            })
            .catch((err) => {
                isfetch.current = false
                isfirst.current = false
                setmodal_load({ enable: false, message: "" })
            });
    }

    function alarm_record_bg_color(data) {
        if (data.Event_Class === "Critical" || data.Event_Class === "Major") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-red"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-red"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-red"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Minor") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-orange"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-orange"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-orange"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Warning") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-yellowe"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-yellow "
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-yellow "
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Info") {
            return ""
        } else if (data.Event_Class === "System") {
            return ""
        }
    }

    function count_isrequired() {
        const index = data_alarmevent_standing.findIndex((element) => element.Ack_Req === true)
        if (index > -1) {
            return true
        }
        return false
    }

    function reorder_data(data) {
        var sortedStrings = data.sort(function (a, b) {
            var aDate = new Date(a.Event_DateTimeStamp_Active);
            var bDate = new Date(b.Event_DateTimeStamp_Active);
            return bDate.getTime() - aDate.getTime();
        });
        return sortedStrings
    }

    async function api_check_online(sitecode, sitename_th) {
        setmodal_load({ enable: true, message: "Connecting to " + sitecode + " " + sitename_th })
        await sleep(500)
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            axios.post(process.env.REACT_APP_API_URL + "/proxy/local/" + sitecode + "/api/authentication/plantinfo", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer GrU5w8y8CKjQPoBCfkjI8fAaoFUP6KLg5xG6h0pfJ2pbfgkPKCc8k522Z7wxy6xb"
                },
            })
                .then((response) => {
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            resolve(true)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    resolve(false)
                })
                .catch((err) => {
                    if (ismount.current) {
                        setmodal_load({ enable: false, message: "" })
                        resolve(false)
                    }
                });
        })
    }

    async function check_site(sitecode, sitename_en, sitename_th, api_url) {
        var state = await api_check_online(sitecode, sitename_th)
        if (state) {
            props.callback_select_site(sitecode, sitename_en, sitename_th, api_url, "/appcenter/alarmevent/realtimeae")
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Site Access Problem',
                message: 'Sorry! Can not access to local site at this time, it\'s seem like connection between central and local has been lose. \r\nPlease try again or contact your system administrator.',
                enable: true
            });
        }
    }

    function gotosite(data) {
        check_site(data.sitecode_text,
            data.sitename_en,
            data.sitename_th,
            "/proxy/local/" + data.sitecode_text,
            "",)
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-alert-rhombus-outline color-orange"></i> Realtime Alarm</h4>
                                    <p className="mb-1">Display all standing alarm.</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {moment(new Date(server_update)).format("YYYY-MM-DD HH:mm:ss")}</h6>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        <div className="d-block">
                            <label htmlFor="reportsite" className="form-label mb-0">Site Name</label>
                            <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                setReportsite(e.target.value)
                            }} required>
                                <option value={"-"} >All Sites</option>
                                {
                                    sitefilter !== null ?
                                        sitefilter.map((data, index) => (
                                            <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                        ))
                                        :
                                        null
                                }
                            </select>
                        </div>
                    </div>

                    <div className="row mt-2 mb-1 mb-md-4">
                        <div className='d-flex justify-content-between flex-wrap mb-2'>
                            <div className='d-block'>
                                <div className='py-0 my-0'><h5 className='py-0 mb-0'>Realtime Alarm List ({data_alarmevent_standing.length} Events)</h5></div>
                                <div className="d-block mt-2">
                                    <h6 className='py-0 my-0 '>Banner Color Definition</h6>
                                    <div className='d-flex gap-3 flex-wrap mt-0'>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-red'></i>Critical, Major</p>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-orange'></i>Minor</p>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle text-yellow'></i>Warning</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-alarm text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Event Class</th>
                                        <th>Event Site</th>
                                        <th>Event DateTime Active</th>
                                        <th className={'' + (count_isrequired() === true ? "" : " d-none")}>Event DateTime InActive</th>
                                        <th>Event Device</th>
                                        {/* <th>Event Tags</th> */}
                                        <th>Category</th>
                                        <th>Status</th>
                                        <th>Acknowledge Status</th>
                                        <th>Message</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role !== "Viewer" ?
                                                    <th width={"40px"}>Action</th>
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        data_alarmevent_standing?.map((data, index) => (
                                            reportsite === "-" || reportsite === data.sitecode_text ?
                                                <tr key={data.Event_ID} className={alarm_record_bg_color(data)}>
                                                    <td className='font-sarabun'>
                                                        <div className='alarm-icon'>
                                                            <i className={"fas fa-bell me-2 "
                                                                + (data.Event_Class === "Critical" || data.Event_Class === "Major" ?
                                                                    "text-danger"
                                                                    : data.Event_Class === "Minor" ?
                                                                        "text-warning"
                                                                        : data.Event_Class === "Warning" ?
                                                                            "text-yellow"
                                                                            : data.Event_Class === "Info" || data.Event_Class === "Hints" ?
                                                                                "text-info"
                                                                                : "rows-icon"
                                                                )}></i>
                                                        </div>
                                                        {data.Event_Class}
                                                    </td>
                                                    <td className='font-sarabun'>
                                                        {data.sitecode_text} {data.sitename_th}
                                                    </td>
                                                    <td className='font-sarabun'>
                                                        {data.Event_DateTimeStamp_Active}
                                                    </td>
                                                    {
                                                        data.Event_Class === "Info" || data.Device_Type === "Server" ?
                                                            <td className={'font-sarabun ' + (count_isrequired() === true ? "" : " d-none")}>-</td>
                                                            :
                                                            <td className={'font-sarabun ' + (count_isrequired() === true ? "" : " d-none")}>{data.Event_DateTimeStamp_InActive}</td>
                                                    }
                                                    <td className='font-sarabun'>{data.Event_Source}</td>
                                                    {/* <td className='font-sarabun'>{data.Event_Tagname}</td> */}
                                                    <td className='font-sarabun'>{data.Event_Category}</td>
                                                    <td className='font-sarabun'>
                                                        {
                                                            data.Event_Class !== "Info" ?
                                                                data.Event_Status ?
                                                                    "Active"
                                                                    :
                                                                    "InActive"
                                                                :
                                                                "-"
                                                        }
                                                    </td>
                                                    <td className='font-sarabun'>
                                                        {
                                                            data.Ack_Req ?
                                                                data.Ack_Status ?
                                                                    "Ack. Pending"
                                                                    :
                                                                    <>
                                                                        <p className='mb-1'>Acked.-{data.Ack_by}</p>
                                                                        <p className='mb-1'>{data.Ack_Time}</p>
                                                                    </>
                                                                :
                                                                "Not Required"
                                                        }
                                                    </td>
                                                    <td className='font-sarabun'>
                                                        <i className={'fas fa-info-circle pe-2 text-blue remark-flags ' + (data.Remark === "" ? "d-none" : "")} onClick={() => { setRemark_display_id(remark_display_id === "" ? data.Event_ID : "") }}></i>
                                                        {data.Message_Str}
                                                        <div className={'mt-1 mb-0 ' + (remark_display_id === data.Event_ID && data.Remark !== "" ? "" : "d-none")}>
                                                            <b>Remark:</b>
                                                            <p className='mt-1 mb-1'>{data.Remark}</p>
                                                        </div>
                                                    </td>
                                                    {
                                                        props.permitdata !== undefined ?
                                                            props.permitdata.user_role !== "Viewer" ?
                                                                <td>
                                                                    <div className='btn-chart-small bg-blue text-white'
                                                                        onClick={() => { gotosite(data) }}>Site ACCESS</div>
                                                                </td>
                                                                :
                                                                null
                                                            : null
                                                    }
                                                </tr>
                                                :
                                                null
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default StandingAlarm